import { ErrorReportingUtils } from '@mm/plugins';

const toString = <T>(value: T): string | undefined => {
  try {
    return JSON.stringify(value);
  } catch (e) {
    ErrorReportingUtils.captureException(e);
    return;
  }
};

const safeParse = <T extends { [key: string]: any }>(
  value?: string,
): T | undefined => {
  if (!value) {
    return;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    ErrorReportingUtils.captureException(error);
    return;
  }
};

const JSONUtils = {
  toString,
  safeParse,
};

export default JSONUtils;
